import HomeIcon from "@mui/icons-material/Home";
import DescriptionIcon from "@mui/icons-material/Description";
import ImportExportIcon from "@mui/icons-material/ImportExport";
export interface PageType {
  label: string;
  navigationLocation: string;
  icon: () => JSX.Element;
  componentName: string;
}

export const SidebarPages: PageType[] = [
  {
    label: "Home",
    navigationLocation: "/",
    icon: () => <HomeIcon />,
    componentName: "Home",
  },
  {
    label: "Jobs",
    navigationLocation: "/jobs",
    icon: () => <DescriptionIcon />,
    componentName: "Jobs",
  },
  {
    label: "Import & Profile",
    navigationLocation: "/import-profile",
    icon: () => <ImportExportIcon />,
    componentName: "ImportProfile",
  },
];
